/* eslint-disable */
import ParametroRepository from '@/services/ParametroRepository'
import PacienteRepository from '@/services/PacienteRepository'


export default {
  namespaced: true,
  state: {
    isTelefonoSet: false,
    listaPacientes: [],
  },
  getters: {
    getIsTelefonoSet(state) {
      return state.isTelefonoSet
    },
    getRedirectedOnce() {
      let temp = JSON.parse(localStorage.getItem('redirectedOnce'))
      return temp
    },
    getHasPacientes(state) {
      return state.listaPacientes.length > 0
    },
    getPacienteTelefono: (state) => (idPaciente) => {
      let paciente = state.listaPacientes.find(paciente => paciente.idPaciente === idPaciente)
      if(paciente){
        return paciente.celular
      }else{
        return null
      }
    }
  },
  mutations: {
    setIsTelefonoSetFlag(state, isSet) {
      if (isSet?.tieneTelefono) {
        state.isTelefonoSet = isSet.tieneTelefono
      }
    },
    setMisPacientes(state, listaPacientes) {
      state.listaPacientes = listaPacientes
    },
    agregarPaciente(state, paciente) {
      state.listaPacientes.push(paciente)
    },
    quitarPaciente(state, paciente) {
      let p = state.listaPacientes.findIndex(p => p.idPaciente === paciente)
      if (p >= 0 && !state.listaPacientes[p].esOperador) {
        state.listaPacientes.splice(p, 1)
      }
    }
  },
  actions: {
    async checkIsTelefonoOperadorSet({ commit }) {
      let isSet = await ParametroRepository.checkTelefono()
      commit('setIsTelefonoSetFlag', isSet)
    },
    async setRedirectedOnce() {
      localStorage.setItem('redirectedOnce', JSON.stringify(true))
    },
    async fetchListaPacientes({ state, commit }) {
      if (state.listaPacientes.length !== 0) {
        return
      }
      let resp = await PacienteRepository.obtenerListaPaciente()
      commit('setMisPacientes', resp)
    },
    async agregarPaciente({ commit, dispatch, rootState }, data) {
      let resp = await PacienteRepository.agregarPaciente(data)
      if (resp) {
        commit('agregarPaciente', resp)
        await dispatch('turnos/stopWebsocket', null, { root: true })
        if (!rootState['turnos/connected']) {
          setTimeout(() => {
            dispatch('turnos/restartWebsocket', null, { root: true })
          }, 20);
        }
      }
    },
    async quitarPaciente({ commit, dispatch, state, rootState }, idPaciente) {
      let resp = await PacienteRepository.quitarPaciente(idPaciente)
      if (resp) {
        commit('quitarPaciente', idPaciente)
        await dispatch('turnos/stopWebsocket', null, { root: true })
        if (!rootState['turnos/connected'] && state.listaPacientes.length !== 0) {
          setTimeout(() => {
            dispatch('turnos/restartWebsocket', null, { root: true })
          }, 20);
        }
      }
    },
  }
}
